<template>
  <el-option v-bind="$attrs"></el-option>
</template>
<script>
export default {
  name: "BaseSelectOption",
};
</script>
